import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';

import { documentPersistedAtom } from '@/atoms/document-persisted';

export const useBreadcrumbs = (
  goBack: (isSearch?: boolean) => void,
  isFromSearch: boolean,
  resourceIsSuccess: boolean,
) => {
  const { t } = useTranslation();
  const { categoryName, subcategoryName, backUrl } = useAtomValue(
    documentPersistedAtom,
  );

  const breadcrumbs = [
    {
      label: t('Generic.explore'),
      to: '/',
    },
    {
      label: categoryName,
      to: backUrl,
      onClick: !backUrl ? () => goBack() : undefined,
    },
    {
      label: subcategoryName,
      to: backUrl,
      onClick: !backUrl ? () => goBack() : undefined,
    },
    // Design wants the chevron right icon to show at the end without a label
    {
      label: '',
    },
  ];

  const breadcrumbsFromSearch = [
    {
      label: t('Generic.search'),
      onClick: () => goBack(true),
    },
    // Design wants the chevron right icon to show at the end without a label
    {
      label: '',
    },
  ];

  const breadcrumbsFromlink = [
    {
      label: t('Generic.explore'),
      to: '/',
    },
    // Design wants the chevron right icon to show at the end without a label
    {
      label: '',
    },
  ];

  return isFromSearch
    ? breadcrumbsFromSearch
    : resourceIsSuccess
      ? breadcrumbsFromlink
      : breadcrumbs;
};
